const REGIONS = {
  se_pacific: {
    id: 'se_pacific',
    name: 'Pacífico Sudeste',
    nameAr: 'جنوب شرق المحيط الهادئ',
    nameEn: 'SE Pacific',
    nameKo: '동남태평양',
    defaultLang: 'es',
    apiBase: '/api',
    bbox: [[-25, -180], [33, -69]],
    timezone: 'America/Lima',
    ports: [
      { id: 'talara', name: 'Talara', lat: -4.58, lon: -81.28, country: 'Perú' },
      { id: 'paita', name: 'Paita', lat: -5.08, lon: -81.10, country: 'Perú' },
      { id: 'lobos_de_afuera', name: 'Lobos de Afuera', lat: -6.95, lon: -80.72, country: 'Perú' },
      { id: 'chimbote', name: 'Chimbote', lat: -9.08, lon: -78.60, country: 'Perú' },
      { id: 'salaverry', name: 'Salaverry', lat: -8.22, lon: -78.99, country: 'Perú' },
      { id: 'huarmey', name: 'Huarmey', lat: -10.07, lon: -78.16, country: 'Perú' },
      { id: 'huacho', name: 'Huacho', lat: -11.11, lon: -77.62, country: 'Perú' },
      { id: 'callao', name: 'Callao', lat: -12.04, lon: -77.14, country: 'Perú' },
      { id: 'cerro_azul', name: 'Cerro Azul', lat: -13.03, lon: -76.49, country: 'Perú' },
      { id: 'pisco', name: 'Pisco', lat: -13.71, lon: -76.22, country: 'Perú' },
      { id: 'atico', name: 'Atico', lat: -16.22, lon: -73.69, country: 'Perú' },
      { id: 'bayovar', name: 'Bayovar', lat: -5.84, lon: -81.13, country: 'Perú' },
      { id: 'caleta_grau', name: 'Caleta Grau', lat: -17.05, lon: -72.05, country: 'Perú' },
      { id: 'matarani', name: 'Matarani', lat: -17.00, lon: -72.10, country: 'Perú' },
      { id: 'ilo', name: 'Ilo', lat: -17.65, lon: -71.34, country: 'Perú' },
      { id: 'tumbes', name: 'Tumbes', lat: -3.56, lon: -80.45, country: 'Perú' },
      { id: 'mancora', name: 'Máncora', lat: -4.10, lon: -81.06, country: 'Perú' },
      { id: 'pimentel', name: 'Pimentel', lat: -6.84, lon: -79.94, country: 'Perú' },
      { id: 'chicama', name: 'Chicama', lat: -7.70, lon: -79.44, country: 'Perú' },
      { id: 'supe', name: 'Supe', lat: -10.80, lon: -77.74, country: 'Perú' },
      { id: 'chancay', name: 'Chancay', lat: -11.56, lon: -77.27, country: 'Perú' },
      { id: 'bahia_independencia', name: 'Bahía Independencia', lat: -14.22, lon: -76.18, country: 'Perú' },
      { id: 'san_juan', name: 'San Juan', lat: -15.33, lon: -75.16, country: 'Perú' },
      { id: 'mollendo', name: 'Mollendo', lat: -17.02, lon: -72.01, country: 'Perú' },
      { id: 'la_libertad', name: 'La Libertad', lat: -2.23, lon: -80.91, country: 'Ecuador' },
      { id: 'manta', name: 'Manta', lat: -0.95, lon: -80.73, country: 'Ecuador' },
      { id: 'guayaquil', name: 'Guayaquil', lat: -2.19, lon: -79.88, country: 'Ecuador' },
      { id: 'buenaventura', name: 'Buenaventura', lat: 3.88, lon: -77.07, country: 'Colombia' },
      { id: 'panama_city', name: 'Ciudad de Panamá', lat: 8.95, lon: -79.55, country: 'Panamá' },
      { id: 'puerto_armuelles', name: 'Puerto Armuelles', lat: 8.28, lon: -82.86, country: 'Panamá' },
      { id: 'pedregal', name: 'Pedregal', lat: 8.37, lon: -82.43, country: 'Panamá' },
      { id: 'puerto_vidal', name: 'Puerto Vidal', lat: 8.15, lon: -81.55, country: 'Panamá' },
      { id: 'mutis', name: 'Mutis', lat: 7.88, lon: -80.92, country: 'Panamá' },
      { id: 'chame', name: 'Chame', lat: 8.58, lon: -79.87, country: 'Panamá' },
{ id: 'arraijan', name: 'Arraiján', lat: 8.88, lon: -79.67, country: 'Panamá' },
      { id: 'puerto_caimito', name: 'Puerto Caimito', lat: 8.87, lon: -79.716, country: 'Panamá' },
      { id: 'chiman', name: 'Chimán', lat: 8.67, lon: -78.57, country: 'Panamá' },
      { id: 'la_palma', name: 'La Palma', lat: 8.41, lon: -78.15, country: 'Panamá' },
    ],
    tideStations: [
      { id: 'callao', name: 'Callao', lat: -12.04, lon: -77.14, country: 'Perú' },
      { id: 'matarani', name: 'Matarani', lat: -17.00, lon: -72.10, country: 'Perú' },
      { id: 'talara', name: 'Talara', lat: -4.58, lon: -81.28, country: 'Perú' },
      { id: 'lobos_de_afuera', name: 'Lobos de Afuera', lat: -6.95, lon: -80.72, country: 'Perú' },
      { id: 'paita', name: 'Paita', lat: -5.08, lon: -81.10, country: 'Perú' },
      { id: 'salaverry', name: 'Salaverry', lat: -8.22, lon: -78.99, country: 'Perú' },
      { id: 'chimbote', name: 'Chimbote', lat: -9.08, lon: -78.60, country: 'Perú' },
      { id: 'pisco', name: 'Pisco', lat: -13.71, lon: -76.22, country: 'Perú' },
      { id: 'caleta_grau', name: 'Caleta Grau', lat: -17.05, lon: -72.05, country: 'Perú' },
      { id: 'atico', name: 'Atico', lat: -16.22, lon: -73.69, country: 'Perú' },
      { id: 'cerro_azul', name: 'Cerro Azul', lat: -13.03, lon: -76.49, country: 'Perú' },
      { id: 'huacho', name: 'Huacho', lat: -11.11, lon: -77.62, country: 'Perú' },
      { id: 'huarmey', name: 'Huarmey', lat: -10.07, lon: -78.16, country: 'Perú' },
      { id: 'bayovar', name: 'Bayovar', lat: -5.84, lon: -81.13, country: 'Perú' },
      { id: 'ilo', name: 'Ilo', lat: -17.65, lon: -71.34, country: 'Perú' },
      { id: 'panama_city', name: 'Ciudad de Panamá', lat: 8.97, lon: -79.57, country: 'Panamá' },
      { id: 'puerto_armuelles', name: 'Puerto Armuelles', lat: 8.28, lon: -82.86, country: 'Panamá' },
      { id: 'pedregal', name: 'Pedregal', lat: 8.37, lon: -82.43, country: 'Panamá' },
      { id: 'puerto_vidal', name: 'Puerto Vidal', lat: 8.15, lon: -81.55, country: 'Panamá' },
      { id: 'mutis', name: 'Mutis', lat: 7.88, lon: -80.92, country: 'Panamá' },
      { id: 'chame', name: 'Chame', lat: 8.58, lon: -79.87, country: 'Panamá' },
      { id: 'arraijan', name: 'Arraiján', lat: 8.88, lon: -79.67, country: 'Panamá' },
      { id: 'chiman', name: 'Chimán', lat: 8.67, lon: -78.57, country: 'Panamá' },
      { id: 'la_palma', name: 'La Palma', lat: 8.41, lon: -78.15, country: 'Panamá' },
    ],
  },
  arabian_sea: {
    id: 'arabian_sea',
    name: 'Mar Arábigo',
    nameAr: 'بحر العرب',
    nameEn: 'Arabian Sea',
    nameKo: '아라비아해',
    defaultLang: 'ar',
    apiBase: '/api',
    bbox: [[5, 48], [27, 68]],
    timezone: 'Asia/Muscat',
    ports: [
      { id: 'salalah', name: 'Salalah', lat: 16.94, lon: 54.09, country: 'Omán' },
      { id: 'muscat', name: 'Mascate', lat: 23.59, lon: 58.54, country: 'Omán' },
      { id: 'suhar', name: 'Suhar', lat: 24.34, lon: 56.74, country: 'Omán' },
      { id: 'duqm', name: 'Duqm', lat: 19.66, lon: 57.70, country: 'Omán' },
      { id: 'sur', name: 'Sur', lat: 22.57, lon: 59.53, country: 'Omán' },
      { id: 'khasab', name: 'Khasab', lat: 26.18, lon: 56.25, country: 'Omán' },
      { id: 'fujairah', name: 'Fujairah', lat: 25.13, lon: 56.34, country: 'Omán' },
      { id: 'aden', name: 'Adén', lat: 12.78, lon: 44.97, country: 'Yemen' },
    ],
    tideStations: [
      { id: 'salalah', name: 'Salalah', lat: 16.94, lon: 54.09, country: 'Omán' },
      { id: 'muscat', name: 'Mascate', lat: 23.59, lon: 58.54, country: 'Omán' },
      { id: 'suhar', name: 'Suhar', lat: 24.34, lon: 56.74, country: 'Omán' },
      { id: 'duqm', name: 'Duqm', lat: 19.66, lon: 57.70, country: 'Omán' },
      { id: 'sur', name: 'Sur', lat: 22.57, lon: 59.53, country: 'Omán' },
      { id: 'khasab', name: 'Khasab', lat: 26.18, lon: 56.25, country: 'Omán' },
      { id: 'fujairah', name: 'Fujairah', lat: 25.13, lon: 56.34, country: 'Omán' },
      { id: 'aden', name: 'Adén', lat: 12.78, lon: 44.97, country: 'Yemen' },
    ],
  },
  tropical_atlantic: {
    id: 'tropical_atlantic',
    name: 'Atlántico Tropical',
    nameAr: 'المحيط الأطلسي الاستوائي',
    nameEn: 'Tropical Atlantic',
    nameKo: '열대 대서양',
    defaultLang: 'es',
    apiBase: '/api',
    bbox: [[-20, -77], [20, 25]],
    timezone: 'America/Noronha',
    ports: [
      { id: 'maracaibo', name: 'Maracaibo', lat: 10.65, lon: -71.61, country: 'Venezuela' },
      { id: 'punto_fijo', name: 'Punto Fijo', lat: 11.70, lon: -70.18, country: 'Venezuela' },
      { id: 'puerto_cabello', name: 'Puerto Cabello', lat: 10.47, lon: -68.01, country: 'Venezuela' },
      { id: 'la_guaira', name: 'La Guaira', lat: 10.60, lon: -66.93, country: 'Venezuela' },
      { id: 'puerto_la_cruz', name: 'Puerto La Cruz', lat: 10.22, lon: -64.62, country: 'Venezuela' },
      { id: 'cumana', name: 'Cumaná', lat: 10.46, lon: -64.17, country: 'Venezuela' },
      { id: 'carupano', name: 'Carúpano', lat: 10.67, lon: -63.25, country: 'Venezuela' },
      { id: 'guiria', name: 'Güiria', lat: 10.57, lon: -62.30, country: 'Venezuela' },
      { id: 'porlamar', name: 'Porlamar', lat: 10.96, lon: -63.85, country: 'Venezuela' },
      { id: 'fortaleza', name: 'Fortaleza', lat: -3.72, lon: -38.52, country: 'Brasil' },
      { id: 'recife', name: 'Recife', lat: -8.05, lon: -34.88, country: 'Brasil' },
      { id: 'salvador', name: 'Salvador', lat: -12.97, lon: -38.51, country: 'Brasil' },
      { id: 'belem', name: 'Belém', lat: -1.45, lon: -48.49, country: 'Brasil' },
      { id: 'tema', name: 'Tema', lat: 5.63, lon: -0.02, country: 'Ghana' },
      { id: 'dakar', name: 'Dakar', lat: 14.69, lon: -17.44, country: 'Senegal' },
    ],
    tideStations: [
      { id: 'maracaibo', name: 'Maracaibo', lat: 10.65, lon: -71.61, country: 'Venezuela' },
      { id: 'punto_fijo', name: 'Punto Fijo', lat: 11.70, lon: -70.18, country: 'Venezuela' },
      { id: 'puerto_cabello', name: 'Puerto Cabello', lat: 10.47, lon: -68.01, country: 'Venezuela' },
      { id: 'la_guaira', name: 'La Guaira', lat: 10.60, lon: -66.93, country: 'Venezuela' },
      { id: 'cumana', name: 'Cumaná', lat: 10.46, lon: -64.17, country: 'Venezuela' },
      { id: 'fortaleza', name: 'Fortaleza', lat: -3.72, lon: -38.52, country: 'Brasil' },
      { id: 'recife', name: 'Recife', lat: -8.05, lon: -34.88, country: 'Brasil' },
      { id: 'salvador', name: 'Salvador', lat: -12.97, lon: -38.51, country: 'Brasil' },
      { id: 'tema', name: 'Tema', lat: 5.63, lon: -0.02, country: 'Ghana' },
      { id: 'dakar', name: 'Dakar', lat: 14.69, lon: -17.44, country: 'Senegal' },
    ],
  },
};

const detectRegion = () => {
  try {
    const storedAllowed = localStorage.getItem('allowedRegions');
    if (storedAllowed) {
      const allowed = JSON.parse(storedAllowed);
      if (Array.isArray(allowed) && allowed.length > 0 && REGIONS[allowed[0]]) {
        return allowed[0];
      }
    }
  } catch (e) { /* ignore */ }

  const saved = localStorage.getItem('region');
  if (saved && REGIONS[saved]) return saved;
  const lang = (navigator.language || '').toLowerCase();
  if (lang.startsWith('ar')) return 'arabian_sea';
  if (lang.startsWith('es')) return 'se_pacific';
  return 'tropical_atlantic';
};

let currentRegion = detectRegion();

export function getCurrentRegion() {
  return currentRegion;
}

export function setCurrentRegion(regionId) {
  if (REGIONS[regionId]) {
    currentRegion = regionId;
    localStorage.setItem('region', regionId);
  }
}

export function getRegionConfig(regionId) {
  return REGIONS[regionId] || REGIONS.se_pacific;
}

export function apiUrl(path) {
  const region = getCurrentRegion();
  const sep = path.includes('?') ? '&' : '?';
  return `${path}${sep}region=${region}`;
}

export function addRegionParam(url) {
  const region = getCurrentRegion();
  const sep = url.includes('?') ? '&' : '?';
  return `${url}${sep}region=${region}`;
}

export function getEezUrl(regionId) {
  return `/eez/${regionId}.json`;
}

export function getMpaUrl(regionId) {
  return `/mpa/${regionId}.json`;
}

export function getIsoParalitoralUrl(regionId) {
  return `/isoparalitorales/${regionId}.json`;
}

export const regionList = Object.entries(REGIONS).map(([id, cfg]) => ({
  id,
  name: cfg.name,
  nameEn: cfg.nameEn,
  nameAr: cfg.nameAr,
  nameKo: cfg.nameKo,
  defaultLang: cfg.defaultLang,
}));

export default REGIONS;
